module.exports = __webpack_public_path__ + "img/sarah_chung.675d5706.png";